import apiService from './api';

export interface KycItem {
    _id: string;
    userId: string;
    status: 'pending' | 'approved' | 'rejected';
    nationalIdNumber?: string;
    submittedAt?: string;
    reviewedAt?: string;
    rejectReason?: string;
}

export interface KycDetail extends KycItem {
    frontImageBase64?: string;
    backImageBase64?: string;
    selfieImageBase64?: string;
}

const kycService = {
    async list(params: { status?: string; q?: string; page?: number; limit?: number } = {}) {
        // وضعیت خالی = همه‌ی وضعیت‌ها؛ پارامترهای خالی را حذف می‌کنیم تا backend روی کل اعمال شود
        const query: Record<string, any> = {};
        if (params.status) query.status = params.status;
        if (params.q && params.q.trim()) query.q = params.q.trim();
        query.page = params.page || 1;
        query.limit = params.limit || 10;
        const response = await apiService.get<any>(`/admin/kyc`, { params: query });
        // apiService returns nested data directly when present → normalize to { data: { ... } }
        const items = response?.items || response?.docs || response?.data || response?.list || [];
        const pages = response?.pages || response?.pagination?.pages || 1;
        const total = response?.total ?? items.length;
        const counts = response?.counts || { all: 0, pending: 0, approved: 0, rejected: 0 };
        return { data: { items, pages, total, counts } };
    },

    async getById(id: string) {
        const response = await apiService.get<any>(`/admin/kyc/${id}`);
        return response;
    },

    async approve(id: string) {
        const response = await apiService.post<any>(`/admin/kyc/${id}/approve`, {});
        return response;
    },

    async reject(id: string, reason: string) {
        const response = await apiService.post<any>(`/admin/kyc/${id}/reject`, { reason });
        return response;
    }
};

export const adminKycService = {
    async rejectLatestByUser(userId: string, reason: string) {
        const response = await apiService.post<any>(`/admin/kyc/by-user/${userId}/reject`, { reason });
        return response;
    }
};

export default kycService;


